import { useState } from "react";
import { useTranslation } from "react-i18next";
import { mainSiteUrl, heroImage } from "@/mocks/categories";

export default function Hero() {
  const { t } = useTranslation();
  const [query, setQuery] = useState("");

  function submitSearch() {
    const q = query.trim();
    if (!q) return;
    const el = document.getElementById("categories");
    el?.scrollIntoView({ behavior: "smooth" });
  }

  return (
    <section className="relative w-full">
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="AllChinaBuy Spreadsheet products and buying resources"
          title="AllChinaBuy Spreadsheet products"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/45" />
      </div>

      <div className="relative z-10 mx-auto max-w-[1280px] px-4 md:px-6 pt-32 pb-24 md:pt-40 md:pb-32">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/20 backdrop-blur px-4 py-1.5 text-xs font-medium text-background-50">
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-shield-check-line" />
            </span>
            {t("hero.badge")}
          </span>

          <h1 className="mt-6 font-heading text-3xl md:text-5xl font-semibold leading-tight text-background-50">
            {t("hero.title")}
          </h1>

          <p className="mt-5 text-base md:text-lg text-background-100 leading-relaxed">
            {t("hero.subtitle")}
          </p>

          <form
            onSubmit={(e) => {
              e.preventDefault();
              submitSearch();
            }}
            className="mt-8 mx-auto max-w-xl flex items-center gap-2 rounded-full bg-background-50 px-4 py-2"
          >
            <span className="w-5 h-5 flex items-center justify-center shrink-0">
              <i className="ri-search-line text-foreground-500 text-sm" />
            </span>
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder={t("hero.searchPlaceholder")}
              className="flex-1 bg-transparent text-sm text-foreground-950 placeholder:text-foreground-400 outline-none"
            />
            <button
              type="submit"
              className="shrink-0 rounded-full bg-primary-500 px-4 py-1.5 text-sm font-semibold text-background-50 hover:bg-primary-600 whitespace-nowrap cursor-pointer"
            >
              {t("nav.products")}
            </button>
          </form>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-primary-600 whitespace-nowrap cursor-pointer"
            >
              {t("hero.ctaPrimary")}
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line" />
              </span>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 rounded-md border border-background-50/60 bg-background-50/10 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-background-50/20 whitespace-nowrap cursor-pointer"
            >
              {t("hero.ctaSecondary")}
            </a>
          </div>

          <p className="mt-6 text-xs text-background-100/90">{t("hero.trust")}</p>
        </div>
      </div>
    </section>
  );
}